<template>
  <div class="inner_content">
    <div class="header">
      <div class="flex">
        <el-button type="primary" size="small" @click="handle"
          >添加消分任务</el-button
        >
        <!-- <div class="box flex">
          <div class="title">活动状态：</div>
          <el-select
            v-model="value"
            placeholder="请选择"
            size="small"
            class="fixedwidth"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="box flex">
          <div class="title">活动日期：</div>
          <el-date-picker
            v-model="value1"
            size="small"
            class=""
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div class="box flex">
          <div class="title"></div>
          <el-input class="fixedwidth" size="small"></el-input>
          <el-button size="small" type="primary" placeholder="请输入活动名称"
            >查询</el-button
          >
        </div> -->
      </div>
    </div>
    <el-table
      :data="tableData"
      size="small"
      :header-cell-style="setHeader"
      height="100%"
      stripe
    >
      <el-table-column prop="listNum" label="序列" width="80">
      </el-table-column>
      <el-table-column
        prop="name"
        label="活动名称"
      ></el-table-column>
      <el-table-column prop="num" label="积分数量"></el-table-column>
      <el-table-column prop="user_mobile" label="会员"></el-table-column>
      <el-table-column prop="des" label="	描述"></el-table-column>
      <el-table-column prop="create_time" label="创建时间"></el-table-column>
      <el-table-column prop="taskStatus" label="任务状态"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.row.id)">
            编辑
          </el-button>
          <el-button size="mini" @click="handleDelete(scope.row.id)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next, jumper"
      :total="total_num"
    >
    </el-pagination>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { PointsTaskIndex, PointsTaskDel } from "@/api/market";
export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      page: "0",
      total_num: 0,
      tableData: [],
      form: {
        value: true,
        name: "",
        region: ""
      },
      formLabelWidth: "120px",
      dialogFormVisible: false,
      options: [
        {
          value: "0",
          label: "全部状态"
        }
      ],
      value1: "",
      value: "",
      headerStyle: {
        background: "rgba(250,250,250,1)",
        color: "#000000"
      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 编辑
    handleEdit(index) {
      this.$router.push(`integralTaskAdd?idE=${index}`);
    },
    // 删除
    handleDelete(id) {
      this.$confirm("确认删除该任务吗？")
        .then(_ => {
          PointsTaskDel({
            token: this.token,
            app_id: this.app_id,
            id: id
          }).then(res => {
            this.$message(res.msg);
            // 更新表格
            this.getData();
          });
          done();
        })
        .catch(_ => {});
    },
    getData() {
      let data = {
        app_id: this.app_id,
        token: this.token,
        page: this.page
      };
      PointsTaskIndex(data).then(res => {
        if (res.code == 200) {
          this.tableData = res.data.data;
          this.tableData.forEach((item, index) => {
            console.log("item", item);
            item.listNum = (res.data.current_page - 1) * 10 + index;
            switch (item.status) {
              case 0:
                item.taskStatus = "进行中";
                break;
              case 1:
                item.taskStatus = "完成";
                break;
              case 2:
                item.taskStatus = "作废";
                break;
            }
          });
          this.total_num = res.data.total;
          console.log("数据", this.tableData);
        }
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getData();
    },
    // 设置表头颜色
    setHeader({ rowIndex }) {
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    },
    handle() {
      this.$router.push({
        path: `integralTaskAdd`
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.inner_content {
  background: #fff;
  padding: 0 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .header {
    width: 100%;
    height: 72px;
    // margin-bottom: 20px;
    .box {
      width: 330px;
      .title {
        min-width: 100px;
        text-align: right;
      }
      .fixedwidth {
        width: 180px;
        display: flex;
        justify-content: space-between;
      }
    }
  }
  .el-table {
    flex: 1;
    overflow-y: auto;
  }
  .el-pagination {
    height: 60px;
    padding-top: 16px;
  }
}
// 通用样式
.flex {
  display: flex;
  align-items: center;
  padding: 10px 0px;
}
</style>
